import { motion } from "framer-motion";
import { GraduationCap, Trophy, Code2, Bot, Wand2, Target } from "lucide-react";

const IMAGE = "https://images.unsplash.com/photo-1542831371-29b0f74f9713?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxzb2Z0d2FyZSUyMGNvZGUlMjB0ZXJtaW5hbCUyMGNvbXB1dGVyfGVufDB8fHx8MTc4MzAwMTI5N3ww&ixlib=rb-4.1.0&q=85";

const TRACKS = [
  { icon: Bot, title: "Workshop de IA", desc: "GenAI, prompt engineering, uso corporativo seguro, agentes e copilots." },
  { icon: Wand2, title: "Low-Code & Vibe Coding", desc: "PowerApps, Power Automate, ferramentas visuais para o time construir soluções." },
  { icon: Code2, title: "Python para Backoffice", desc: "Automação de rotinas fiscais, ETL, pandas, APIs e integração com ERP." },
  { icon: Trophy, title: "Hackathons Internos", desc: "Sprints temáticas para acelerar a cultura de inovação com resultado real." },
  { icon: Target, title: "Criação de KPIs", desc: "Como medir o que importa, montar dashboards e evoluir tomada de decisão." },
  { icon: GraduationCap, title: "Mentoria & Acompanhamento", desc: "Ciclos mensais de mentoria com o time para sustentar autonomia." },
];

export default function Academy() {
  return (
    <section id="academy" className="relative py-28 md:py-36 bg-[#050F26]/40" data-testid="academy-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-14 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <p className="label-eyebrow">Trilha de capacitação</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-4 leading-tight tracking-tight text-white">
              Ponzena <span className="gradient-text">Academy</span>.
            </h2>
            <p className="mt-6 text-lg text-[#B8C0D0] leading-relaxed">
              Não basta entregar tecnologia — precisamos <em className="text-white not-italic">deixar o time capaz</em> de evoluir sozinho. A trilha combina workshops, hackathons, mentoria e sprints práticas, todas focadas em resultado no backoffice.
            </p>
            <div className="mt-8 relative rounded-2xl overflow-hidden border border-cyan-400/20">
              <img src={IMAGE} alt="Coding" className="w-full aspect-video object-cover opacity-70" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#030B1E] via-[#030B1E]/40 to-transparent" />
              <div className="absolute bottom-4 left-4 right-4">
                <p className="font-mono-tech text-xs text-cyan-400 tracking-widest">// AUTONOMIA COM SEGURANÇA</p>
                <p className="font-display text-lg text-white mt-1">Vibe coding + compliance = evolução contínua.</p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5" data-testid="academy-tracks">
            {TRACKS.map((t, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                className="card-surface p-6"
                data-testid={`academy-track-${i}`}
              >
                <t.icon size={24} className="text-cyan-400" />
                <h3 className="font-display text-xl font-semibold text-white mt-4">{t.title}</h3>
                <p className="mt-2 text-sm text-[#8892B0] leading-relaxed">{t.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
